enum OrderClientEntryPoints {
  getCollection = '/api/sale/order-client/list',
  getCollectionByClient = '/api/sale/order-client/list/{uuid}',
  getCollectionByShop = '/api/shop/sales/order-client/list/{shopId}',

  getCollectionPreparer = '/api/inventory-management/preparer-manager/orders',
  getCollectionCarriersPreparer = '/api/inventory-management/preparer-manager/carriers',

  getCollectionShopPayment = '/api/accounting/shop-payment/list',
  getCollectionShopPaymentDownload = '/api/accounting/shop-payment/download',
}

export default OrderClientEntryPoints;
